var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-skeleton", { attrs: { animation: "fade", width: "10%" } }),
      _vm._v(" "),
      _c("b-skeleton", {
        attrs: {
          type: "input",
          animation: "fade",
          width: "95%",
          height: "1.5rem",
        },
      }),
      _vm._v(" "),
      _c("b-skeleton", {
        staticClass: "mt-2",
        attrs: { animation: "fade", width: "10%" },
      }),
      _vm._v(" "),
      _c("b-skeleton", {
        attrs: {
          type: "input",
          animation: "fade",
          width: "95%",
          height: "1.5rem",
        },
      }),
      _vm._v(" "),
      _c("b-skeleton", {
        staticClass: "mt-2",
        attrs: { animation: "fade", width: "10%" },
      }),
      _vm._v(" "),
      _c("b-skeleton", {
        attrs: {
          type: "input",
          animation: "fade",
          width: "95%",
          height: "1.5rem",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }